import request from '@/utils/request';
import { BASE_API } from '@/utils/consts'

export function queryClinicInfo(data) {
  return request(`${BASE_API}/clinic/show/${data.id}`)
}

// 获取岗位列表
export function getJob(data) {
  return request(`${BASE_API}/job_position/list`, { method: 'POST', data })
}

// const BASE_API = '/apid'
// 添加诊所
export function addClinic(data) {
  return request(`${BASE_API}/clinic/create`, {
    method: 'POST',
    data
  });
}
// 编辑诊所
export function updateClinic(data) {
  return request(`${BASE_API}/clinic/update`, {
    method: 'POST',
    data
  })
}
// 角色列表
export function queryRoleList(data) {
  return request(`${BASE_API}/role/clinic/list`, {
    method: 'POST',
    data
  })
}
// 添加角色
export function addRoleClinic(data) {
  return request(`${BASE_API}/role/clinic/create`, {
    method: 'POST',
    data
  })
}
// 编辑角色
export function updateRoleClinic(data) {
  return request(`${BASE_API}/role/clinic/update`, {
    method: 'PUT',
    data
  })
}

// 删除角色
export function deleteRoleClinic(data) {
  return request(`${BASE_API}/role/delete_clinic/${data.id}/${data.clinic_id}`, {
    method: 'DELETE'
  })
}

// 查询未添加的系统默认角色
export function querySystemRole(data) {
  return request(`${BASE_API}/role/system/list`, {
    method: 'POST',
    data
  })
}

// 添加系统默认角色到诊所
export function setClinicRoleFromSys(data) {
  return request(`${BASE_API}/role/clinic/add_from_sys`, {
    method: 'POST',
    data
  });
}

// 查询诊所组织机构
export function queryClinicOrganizations(data) {
  return request(`${BASE_API}/clinic/show_organization/${data.id}`);
}

// 查询用户
export function queryMembers(data) {
  return request(`${BASE_API}/users/list_clinic_employee`, {
    method: 'POST',
    data
  });
}

// 添加部门
export function addClinicDepartment(data) {
  return request(`${BASE_API}/organization/create`, {
    method: 'POST',
    data
  });
}

// 编辑部门
export function updateClinicDepartment(data) {
  return request(`${BASE_API}/organization/update`, {
    method: 'PUT',
    data
  });
}

// 查询部门详情
export function queryDepartment(data) {
  return request(`${BASE_API}/organization/show/${data.id}`);
}

// 查询用户详情
export function getUserInfo(data) {
  return request(`${BASE_API}/users/find/${data.username}`, { method: 'GET' });
}

// 删除部门
export function deleteClinicDepartment(data) {
  return request(`${BASE_API}/organization/delete/${data.id}`, {
    method: 'DELETE',
  });
}

// 查询诊所角色下拉菜单
export function queryAllClinicRoles(data) {
  return request(`${BASE_API}/role/clinic/selection_list`, {
    method: 'GET',
    data
  })
}

// 添加诊所员工
export function addClinicMember(data) {
  return request(`${BASE_API}/users/create_employee`, {
    method: 'POST',
    data
  });
}

// 编辑诊所员工
export function updateClinicMember(data) {
  return request(`${BASE_API}/users/update_employee`, {
    method: 'PUT',
    data
  });
}

// 编辑诊所员工
export function toggleMemberStatus(data) {
  return request(`${BASE_API}/users/lock/${data.userId}`, {
    method: 'PUT',
  });
}

// 编辑诊所员工
export function deleteMember(data) {
  return request(`${BASE_API}/users/delete/${data.userId}`, {
    method: 'DELETE'
  });
}

export function queryPermissionList(data) {
  return request(`${BASE_API}/permission/list`, { method: 'POST', data });
}

// 诊所编码是否已存在
export function isCodeExist(data) {
  return request(`${BASE_API}/clinic/is_code_exist`, {
    data
  });
}
// 查询员工编号是否存在
export function checkUsernameExist(data) {
  return request(`${BASE_API}/users/is_username_exist`, {
    data
  });
}

// 查询手机号是否存在
export function checkPhoneExist(data) {
  return request(`${BASE_API}/users/is_phone_exist`, {
    data
  });
}

//更新员工排序字段
export function updateSort(data) {
  return request(`${BASE_API}/employee/batch-update_sort`, {
    method: 'POST',
    data
  });
}
export function updatePerformance(data) {
  return request(`${BASE_API}/employee/update_performance`, {
    method: 'POST',
    data
  })
}
export function updateworkerSort(data) {
  return request(`${BASE_API}/employee/update_sort`, {
    method: 'POST',
    data
  })
}
// 重置统计排序
export function resetSort(id) {
  return request(`${BASE_API}/employee/clean_sort/${id}`, {
    method: 'POST'
  })
}

// 交接信息查询
export function fetchJobChangeInfo(data) {
  return request(`${BASE_API}/users/job_pass_info/${data.clinicId}/${data.userId}`)
}
// 提交职位变动信息
export function submitJobChange(data) {
  return request(`${BASE_API}/users/job_pass_info/create`, {
    method: 'POST',
    data
  })
}
// 职位变动审核
export function fetchJobChangeExamine(data) {
  return request(`${BASE_API}/users/job_pass_info/confirm/${data.clinicId}/${data.userId}/${data.isPass}`)
}
export function queryOrders(data) {
  return request(`${BASE_API}/order/list`, {
    method: 'POST',
    data
  });
}